import { gateway } from "../../../../gateway";

export const getNotificationCountByCompany = async () => {
  const res = await gateway.get("/notifications/self/count-by-company");

  return res.data?.data ?? res.data ?? [];
};
